import apiFetch from '../../apiFetch'

export default function (idIntervencionSanitaria, token) {
  return apiFetch({endPoint: `Intervencion/deleteIntervencion?idIntervencion=` + idIntervencionSanitaria, method: 'GET', body: null, token: token})
}